import { createSharedComposable } from '@vueuse/core'
import { useShowFramework } from './show-framework'

export const useDimension = createSharedComposable(() => {
    const showFramework = useShowFramework()

    return useQuery<string | undefined>('dimension', {
        set(value) {
            showFramework.value = false
            return value?.toString()
        },
        defaultValue: undefined
    })
})
